/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TrainingNoteType {
    Session = 'SESSION',
    Player = 'PLAYER',
    Match = 'MATCH',
    Personal = 'PERSONAL'
}


export function instanceOfTrainingNoteType(value: any): boolean {
    for (const key in TrainingNoteType) {
        if (Object.prototype.hasOwnProperty.call(TrainingNoteType, key)) {
            if (TrainingNoteType[key as keyof typeof TrainingNoteType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrainingNoteTypeFromJSON(json: any): TrainingNoteType {
    return TrainingNoteTypeFromJSONTyped(json, false);
}

export function TrainingNoteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingNoteType {
    return json as TrainingNoteType;
}

export function TrainingNoteTypeToJSON(value?: TrainingNoteType | null): any {
    return value as any;
}

export function TrainingNoteTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TrainingNoteType {
    return value as TrainingNoteType;
}

